import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as runActions from '../../../actions/runsActionCreators';
import * as studentActions from '../../../actions/studentsActionCreators';
import * as courseActions from '../../../actions/coursesActionCreators';
import * as commonActions from '../../../actions/commonActions';
import moment from 'moment';
import SchedulesContainer from './SchedulesContainer';

class Schedules extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      events: []
    };
  }

  getInRangeByFilters = (startDate, endDate) => {
    const { filteredDays } = this.props;

    if (!filteredDays) {
      return true;
    }

    const startDayFilter = moment(filteredDays[0]); // initial date of the range
    const endDayFilter = moment(filteredDays[filteredDays.length - 1]);
    const startDateCourse = moment(startDate); // initial day of the course
    const endDateCourse = moment(endDate); // end day of the course

    const inRange = startDayFilter // checks if the start day of the picked week is between the start date and end date of the meeting
      .isBetween(startDateCourse, endDateCourse, null, '[]') ||
      endDayFilter // checks if the end day of the picked week is between the start date and end date of the meeting
        .isBetween(startDateCourse, endDateCourse, null, '[]');

    return inRange;
  }

  prepareSchedules(schedules) {
    let schedulesArray = [];
    if (schedules.length != 0) {
      schedules.map(schedule => {
        let courses = [];
        let schedulesNoMeetings = [];
        let schedulesMeetings = [];

        schedule.map(id => {
          let a = commonActions.getCourseObjById(id, this.props.courses);
          courses.push(a);
        });
        if (courses.length > 0) {
          courses.map(course => {
            if (course.meetings.length > 0) {
              console.debug(`schedulesMeetings [course.longname] - ${JSON.stringify(course.longname, null, 2)}`)

              schedulesMeetings.push(course);
            } else {
              schedulesNoMeetings.push(course);
            }
          });
        }

        // Events in arrays by days from Monday to Friday
        let events = [[], [], [], [], [], [], []];

        schedulesMeetings.map(c => {
          c.meetings.map(m => {
            const endDate = m.enddate;
            const startDate = m.startdate;

            if (this.getInRangeByFilters(startDate, endDate)) {
              let startTime = +m.starttime.substring(0, 2) + m.starttime.substring(3, 5) / 60;
              let endTime = +m.endtime.substring(0, 2) + m.endtime.substring(3, 5) / 60;
  
              if (startTime < 7 || endTime > 22) {
                schedulesNoMeetings.push(c);
              } else {
                let startPx = startTime - 7;
                let endPx = endTime - 7;
                let smom = new moment(m.starttime, 'HH:mm:ss');
                let emom = new moment(m.endtime, 'HH:mm:ss');
                let eTime = emom.format('h:mm a');
                let sTime = smom.format('a') == emom.format('a') ? smom.format('h:mm') : smom.format('h:mm a');
  
                let o = {
                  id: c.id,
                  slug: c.slug,
                  time: `${sTime}-${eTime}`,
                  instructor: c.instructor,
                  longname: c.longname,
                  start: startPx,
                  end: endPx,
                  external_url: c.external_url
                };
                events[m.day - 1].push(o);
              }
            }
          });
        });
        schedulesNoMeetings = commonActions.unique(schedulesNoMeetings);
        let obj = {
          noMeetings: schedulesNoMeetings,
          events: events
        };
        schedulesArray.push(obj);
      });
      return schedulesArray;
    } else {
      return schedulesArray;
    }
  }

  render() {
    return (
      <div>
        {this.props.topks.map((topk, index) => {
          let schedules = this.prepareSchedules(topk.schedules);
          return <SchedulesContainer key={JSON.stringify(schedules) + index} schedules={schedules} number={index} />;
        })}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    run: state.run,
    student: state.student,
    courses: state.courses
  };
}

function mapDispatchToProps(dispatch) {
  return {
    runActions: bindActionCreators(runActions, dispatch),
    studentActions: bindActionCreators(studentActions, dispatch),
    courseActions: bindActionCreators(courseActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Schedules);



// WEBPACK FOOTER //
// ./src/components/rank/schedules/Schedules.js